import Vue from 'vue'
import vuexI18n from 'vuex-i18n'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMatomo from 'vue-matomo'

import getLanguage from './language'
import ApiService from './api/api.config'

import translationsEn from './assets/i18n/authentication/EN.json'
import translationsFr from './assets/i18n/authentication/FR.json'
import translationsPl from './assets/i18n/authentication/PL.json'
import translationsEs from './assets/i18n/authentication/ES.json'
import translationsIt from './assets/i18n/authentication/IT.json'
import translationsDe from './assets/i18n/authentication/DE.json'
import translationsPt from './assets/i18n/authentication/PT.json'
import translationsNl from './assets/i18n/authentication/NL.json'

import './assets/styles/variable.scss'
import './assets/styles/font.scss'
import './assets/styles/form.scss'
import './assets/styles/index.scss'
import './assets/styles/input.scss'
import './assets/styles/icon.scss'
import './assets/styles/button.scss'
import './assets/styles/auth.scss'

Vue.config.productionTip = false
ApiService.init()

Vue.use(vuexI18n.plugin, store)

// add translations directly to the application
Vue.i18n.add('EN', translationsEn)
Vue.i18n.add('FR', translationsFr)
Vue.i18n.add('PL', translationsPl)
Vue.i18n.add('ES', translationsEs)
Vue.i18n.add('IT', translationsIt)
Vue.i18n.add('DE', translationsDe)
Vue.i18n.add('PT', translationsPt)
Vue.i18n.add('NL', translationsNl)

Vue.i18n.set(getLanguage(['EN', 'FR', 'PL', 'ES', 'IT', 'DE','PT', 'NL']))

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    ApiService.initTracker(router)
  }
}).$mount('#app')

const app = Vue.i18n
export default app
